export type ColorOutcomeType<
  Light extends string,
  Dark extends string,
> = `var(--is-light-theme, ${Light}) var(--is-dark-theme, ${Dark})`

export type Color = `#${string}`

const getCSSVariable = <Light extends string, Dark extends string>({
  light,
  dark,
}: {
  light: Light
  dark: Dark
}): ColorOutcomeType<Light, Dark> =>
  `var(--is-light-theme, ${light}) var(--is-dark-theme, ${dark})` as const

const extractLightAndDarkColor = <Light extends Color, Dark extends Color>(
  color: ColorOutcomeType<Light, Dark>
) => {
  const colors = Array.from(color.matchAll(/#([0-9a-fA-F]{6})/g))
  return {
    light: colors[0][0] as Light,
    dark: colors[1][0] as Dark,
  }
}

const getHexOpacityColor = <
  Light extends Color,
  Dark extends Color,
  Opacity extends string,
>(
  color: ColorOutcomeType<Light, Dark>,
  opacity: Opacity
) => {
  const { light, dark } = extractLightAndDarkColor(color)

  return getCSSVariable({
    light: `${light}${opacity}`,
    dark: `${dark}${opacity}`,
  })
}
export { getCSSVariable, getHexOpacityColor }
